import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { persistor, store } from "_redux/store";
import AppThemeProvider from "_context/AppThemeProvider";
import { injectStore } from "_helpers";
import { BrowserRouter } from "react-router-dom";
import { AuthRoutes } from "_lib";
import { AppLayout, GlobalStyles } from "_core";

function App() {
  injectStore(store);
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <AppThemeProvider>
          <BrowserRouter>
            <AuthRoutes>
              <GlobalStyles />
              <AppLayout />
            </AuthRoutes>
          </BrowserRouter>
        </AppThemeProvider>
      </PersistGate>
    </Provider>
  );
}

export default App;
